export const displayFontSize = {
  display1: 48,
  display2: 40,
  display3: 36,
  display4: 28,
  display5: 24,
} as const;

export type DisplayFontSizeKeys = keyof typeof displayFontSize;

export const displayLineHeight = {
  display1: 38, // 48px × 0.8
  display2: 32, // 40px × 0.8
  display3: 32, // 36px × 0.9
  display4: 28, // 28px × 1.0
  display5: 24, // 24px × 1.0
} as const;

// Compensation values to prevent glyph clipping with tight line heights
// Apply as paddingTop (positive) and marginTop (negative) on text elements
export const displayLineHeightCompensation = {
  display1: displayFontSize.display1 - displayLineHeight.display1,
  display2: displayFontSize.display2 - displayLineHeight.display2,
  display3: displayFontSize.display3 - displayLineHeight.display3,
  display4: displayFontSize.display4 - displayLineHeight.display4,
  display5: displayFontSize.display5 - displayLineHeight.display5,
} as const;

// 2% of font size, in pixels for React Native compatibility
export const displayLetterSpacing = {
  display1: 0.96, // 48px × 2%
  display2: 0.8, // 40px × 2%
  display3: 0.72, // 36px × 2%
  display4: 0.56, // 28px × 2%
  display5: 0.48, // 24px × 2%
} as const;

export const khTekaFontSize = {
  title1: 36,
  title2: 32,
  title3: 28,
  title4: 24,
  title5: 20,
  subtitle1: 16,
  subtitle2: 14,
  subtitle3: 12,
  body1: 16,
  body2: 14,
  body3: 12,
  label1: 16,
  label2: 14,
  label3: 12,
  legal: 10,
} as const;

export type KhTekaFontSizeKeys = keyof typeof khTekaFontSize;

export const khTekaLineHeight = {
  title1: 36, // 36 × 1.0
  title2: 32, // 32 × 1.0
  title3: 28, // 28 × 1.0
  title4: 24, // 24 × 1.0
  title5: 20, // 20 × 1.0
  subtitle1: 21, // 16 × 1.3
  subtitle2: 18, // 14 × 1.3
  subtitle3: 14, // 12 × 1.2
  body1: 21, // 16 × 1.3
  body2: 18, // 14 × 1.3
  body3: 14, // 12 × 1.2
  label1: 16, // Trim (1.0×)
  label2: 14, // Trim (1.0×)
  label3: 12, // Trim (1.0×)
  legal: 12, // 10 × 1.2
} as const;
